@if (isAerohive()) {
  <a class="shortcut-menu__button" href="https://extremecloudiq.com" target="_blank">
    <svg-icon src="assets/images/icons/out.svg"></svg-icon>
    <span>{{ "ShortcutMenu.Hive" | translate }} </span>
  </a>
} @else {
  <a class="shortcut-menu__button" href="https://auth.hpe.com/" target="_blank">
    <svg-icon src="assets/images/icons/out.svg"></svg-icon>
    <span>{{ "ShortcutMenu.ArubaCentral" | translate }} </span>
  </a>
}
